import React from 'react';
import PropTypes from 'prop-types';
import { Stack } from '@mui/material';
import { AttachmentViewerModal, DataGrid, FileTypeEnum } from '@orijinworks/frontend-commons';
import { useFormsHook } from './useFormsHook';
import { FORM_SOURCE } from './constants/form-source.constants';

/**
 * Forms list (DataGrid). Form.io builder lives in `FormManage.js` (routes `/forms`, `/forms/:formId`).
 * Composed by Feeds and Re-Entry Planning; `source` (see `FORM_SOURCE`) decides where sub-pages return.
 */
const Forms = React.memo(({ source }) => {
  const {
    columns,
    data,
    pageSize,
    loading,
    refreshForms,
    primaryButtonProps,
    secondaryButtonProps,
    previewForm,
    clearPreviewForm,
  } = useFormsHook({ source });

  return (
    <Stack
      height="100%"
      backgroundColor="white"
      direction="column"
      spacing={2}
      padding="20px"
    >
      {previewForm != null && (
        <AttachmentViewerModal
          fileName={previewForm.name ?? 'Form'}
          fileType={FileTypeEnum.OTHER}
          formReadOnly
          formSchema={previewForm.schema ?? undefined}
          open
          onClose={clearPreviewForm}
        />
      )}
      <DataGrid
        columns={columns}
        data={[...data]}
        pageSize={pageSize}
        pageSizeOptions={[5, 10, 25, 50]}
        paginationMode="client"
        isLoading={loading}
        isAllSelected={false}
        showSelection={false}
        onSelectionChange={() => {}}
        onRefreshHandler={refreshForms}
        hasActionColumn
        primaryButtonProps={primaryButtonProps}
        secondaryButtonProps={secondaryButtonProps}
        tableSx={{
          minWidth: 0,
          width: '100%',
          maxWidth: '100%',
        }}
        tdStyles={{
          name: {
            width: 220,
            minWidth: 220,
            maxWidth: 220,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            wordBreak: 'normal',
          },
          createdBy: {
            width: 200,
            minWidth: 160,
            maxWidth: 260,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            wordBreak: 'normal',
          },
          active: {
            width: 150,
            maxWidth: 150,
          },
          submissionCount: {
            width: 160,
            maxWidth: 160,
          },
        }}
      />
    </Stack>
  );
});

Forms.propTypes = {
  source: PropTypes.oneOf(Object.values(FORM_SOURCE)),
};

export default Forms;
